import React from 'react';
import { useTranslation } from 'react-i18next';

const statusColors = {
  'In-Transit': 'bg-blue-500',
  Delivered: 'bg-green-500',
  Delayed: 'bg-red-500',
  Pending: 'bg-yellow-400',
};

const DispatchTable = ({
  data,
  currentPage,
  totalDocs,
  hasPrevPage,
  hasNextPage,
  modalLoading,
  onViewClick,
  onPrevPage,
  onNextPage,
}) => {
  const { t, i18n } = useTranslation();

  return (
    <div className="overflow-x-auto bg-[#1D2461] rounded-lg">
      <table className="min-w-full table-fixed text-sm text-left">
        <thead className="bg-[#B2BAFF] text-[#202224] font-nunito uppercase text-[14px]">
          <tr>
            <th className="p-4 w-12">
              <input type="checkbox" aria-label={t('alt.selectAll')} />
            </th>
            <th className="p-4 w-24">{t('orders.containerId')}</th>
            <th className="p-4 w-24">{t('orders.poNumber')}</th>
            <th className="p-4 w-32">{t('orders.originDestination', { origin: '', destination: '' })}</th>
            <th className="p-4 w-20">{t('orders.statusLabel')}</th>
            <th className="p-4 w-24">{t('orders.actions')}</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((row, idx) => (
              <tr key={idx} className="border-t border-[#2A2A4D]">
                <td className="p-4">
                  <input type="checkbox" aria-label={t('alt.selectRow', { index: idx + 1 })} />
                </td>
                <td className="p-4">{row.id}</td>
                <td className="p-4">{row.order}</td>
                <td className="p-4">{row.origin} → {row.destination}</td>
                <td className="p-4">
                  <span className="inline-flex items-center gap-2">
                    <span className={`w-3 h-3 rounded-full ${statusColors[row.status] || 'bg-gray-500'}`}></span>
                    {t(`dashboard.status.${row.status.toLowerCase()}`, { defaultValue: row.status })}
                  </span>
                </td>
                <td className="p-4">
                  <button
                    onClick={() => onViewClick(row._id)}
                    className="bg-[#00B69B] text-white px-4 py-1 rounded-2xl hover:bg-blue-600"
                    disabled={modalLoading}
                    aria-label={t('alt.viewShipment', { id: row.id })}
                  >
                    {modalLoading ? t('dashboard.loading') : t('orders.view')}
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={6} className="text-center text-gray-400 py-6">
                {t('dashboard.noDataFound', { defaultValue: 'No Data Found' })}
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <div className="flex justify-between items-center text-sm text-gray-400 p-4">
        <div>
          Showing {data.length > 0
            ? `${(currentPage - 1) * 10 + 1}-${Math.min(currentPage * 10, totalDocs)} of ${totalDocs}`
            : '0'}
        </div>
        <div className="flex gap-4">
          <button
            onClick={onPrevPage}
            disabled={!hasPrevPage}
            className={`px-4 py-2 rounded-md ${hasPrevPage ? 'bg-[#00B69B] text-white hover:bg-blue-600' : 'bg-gray-500 text-gray-300 cursor-not-allowed'}`}
            aria-label={t('alt.previousPage')}
          >
            {t('dashboard.previous')}
          </button>
          <button
            onClick={onNextPage}
            disabled={!hasNextPage}
            className={`px-4 py-2 rounded-md ${hasNextPage ? 'bg-[#00B69B] text-white hover:bg-blue-600' : 'bg-gray-500 text-gray-300 cursor-not-allowed'}`}
            aria-label={t('alt.nextPage')}
          >
            {t('dashboard.next')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DispatchTable;